import 'react-datepicker/dist/react-datepicker.css'
import { Provider } from '@debbie/cortex/dist/index.js'
import Authenticate from '@debbie/iris/dist/components/Authenticate.js'
import X from '@debbie/iris/dist/components/X.js'
import * as Sentry from '@sentry/browser'
import moment from 'moment'
import React from 'react'
import { StyleSheetManager, styled } from 'styled-components'

import logo from './assets/images/logo.svg'
import { ENABLE_SENTRY, SENTRY_DSN } from './config.js'
import LoggedInView from './LoggedInView.js'
if (ENABLE_SENTRY && SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Never send IP addresses or other default PII to Sentry (GDPR).
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration({
        // Mask all rendered text and input values and block all media before
        // anything leaves the browser. Do NOT disable or add unmask overrides —
        // debtor/creditor PII (names, amounts, CPR) must never reach Sentry.
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    // Record 10% of ordinary sessions and 100% of sessions that hit an error.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
import ErrorBoundary from '@debbie/iris/dist/components/ErrorBoundary.js'
import { ErrorPage } from '@debbie/iris/dist/components/ErrorPage.js'
import isPropValid from '@emotion/is-prop-valid'
import { StyledTarget } from 'styled-components/dist/types.js'

moment.locale()

const Wrapper = styled.div``

function shouldForwardProp(propName: string, target: StyledTarget<'web'>) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}

const App = () => {
  return (
    // @ts-ignore
    <ErrorBoundary fallback={<ErrorPage />}>
      <StyleSheetManager
        enableVendorPrefixes
        shouldForwardProp={shouldForwardProp}
      >
        <Wrapper>
          <Provider>
            <X
              logo={logo}
              loggedInView={
                <Authenticate>
                  <LoggedInView />
                </Authenticate>
              }
            />
          </Provider>
        </Wrapper>
      </StyleSheetManager>
    </ErrorBoundary>
  )
}

export default App
